import React, { Suspense, lazy } from 'react';
import AuthProvider from './store/authContextProvider/AuthProvider';
import { ErrorBoundary } from './components/Error';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ModalProvider from 'store/modalContextProvider/ModalContextProvider';
import UserProvider from 'store/userContextProvider/UserProvider';
import './index.css';

const Header = lazy(() => import('./components/Header'));
const DashboardLayout = lazy(
  () => import('./components/dashboard/DashboardLayout')
);
const Login = lazy(() => import('./components/Authentication'));

const Error = lazy(() => import('./components/Error/Error'));
const NotFound = lazy(() => import('./components/Error/404'));

const App = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Suspense fallback={<div />}>
          <AuthProvider>
            <ModalProvider>
              <UserProvider>
                <div className="animate__animated animate__fadeIn td-200">
                  <Header />
                  <Routes>
                    <Route path="*" element={<DashboardLayout />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/*" element={<DashboardLayout />} />
                    <Route path="/error" element={<Error />} />
                    <Route path="/*" element={<NotFound />} />
                  </Routes>
                </div>
              </UserProvider>
            </ModalProvider>
          </AuthProvider>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
